// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-up h1 {
  margin-bottom: 0;
  margin-top: 30px;
  padding-bottom: 5px;
  color: #191919;
}
.sign-up h2 {
  color: #191919;
}
.sign-up h3 {
  color: #191919;
}
.sign-up h4 {
  color: #191919;
}
.sign-up body {
  color: #191919;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup/signup.component.scss"],"names":[],"mappings":"AACI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACI,cAAA;AAAV;AAEM;EACI,cAAA;AAAV;AAEM;EACI,cAAA;AAAV;AAEM;EACI,cAAA;AAAV;AAEM;EACI,cAAA;AAAV","sourcesContent":[".sign-up {\n    h1 {\n      margin-bottom: 0;\n      margin-top: 30px;\n      padding-bottom: 5px;\n          color: #191919;\n    }\n      h2 {\n          color: #191919;\n      }\n      h3 {\n          color: #191919;\n      }\n      h4 {\n          color: #191919;\n      }\n      body {\n          color: #191919;\n      }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
